var _circle, _rect, _circle2, _line, _line2, _line3, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 95,
    fill: "#7393B3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 40,
    width: 40,
    height: 120,
    fill: "#ffffff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 180,
    r: 10,
    fill: "#ffffff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 80,
    x2: 140,
    y2: 80,
    stroke: "#2c3e50",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 110,
    x2: 140,
    y2: 110,
    stroke: "#2c3e50",
    strokeWidth: 5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 140,
    x2: 140,
    y2: 140,
    stroke: "#2c3e50",
    strokeWidth: 5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "75%",
    fontSize: 16,
    fill: "#ffffff",
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif"
  }, "Stream Inheritance")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5a0c375109b58caefec9cee70a52423f.svg";
export { ForwardRef as ReactComponent };